import { render } from "./AdminReferralUserOverview.vue?vue&type=template&id=562abd0c&scoped=true"
import script from "./AdminReferralUserOverview.vue?vue&type=script&lang=js"
export * from "./AdminReferralUserOverview.vue?vue&type=script&lang=js"

import "./AdminReferralUserOverview.vue?vue&type=style&index=0&id=562abd0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562abd0c"]])

export default __exports__